import * as actionsCommon from '@/store/actions'
import {
  CHANGE_TIMESLOTS_PAGINATION_NEW_PAGE,
  CHANGE_TIMESLOTS_PAGINATION_PER_PAGE,
  CHANGE_TIMESLOTS_REQUEST_FILTER_PARAMS,
  CHANGE_TIMESLOTS_REQUEST_SORT_PARAMS,
  FETCH_TIMESLOTS,
  GET_IS_LOADING_TIMESLOTS,
  GET_TERMINAL_QUOTA_FILTER,
  GET_TIMESLOTS_CURRENT_STEP,
  GET_TIMESLOTS_FROM_STATE,
  GET_TIMESLOTS_PAGINATION,
  GET_TIMESLOTS_STATISTIC_FROM_STATE,
  SET_IS_LOADING_TIMESLOTS,
  SET_TIMESLOTS,
  SET_TIMESLOTS_PAGINATION,
  SET_TIMESLOTS_PAGINATION_CURRENT_PAGE,
  SET_TIMESLOTS_PAGINATION_PER_PAGE,
  SET_TIMESLOTS_QUOTA_FILTER,
  SET_TIMESLOTS_REQUEST_FILTER_PARAMS,
  SET_TIMESLOTS_REQUEST_SORT_PARAMS,
  SET_TIMESLOTS_STATISTICS,
  SET_TIMESLOT_CURRENT_STEP,
} from '@/views/laboratory/store/actions'
import { initialPagination } from '@/constants/pagination'
import {
  laboratoryColumnActions,
  laboratoryColumnGetters,
  laboratoryColumnMutations,
  laboratoryColumnState,
} from '@/views/laboratory/store/laboratory-columns'
import { preparePagination } from '@/core'

import API from '@/api'

const initialTimeslotsStatistic = {
  laboratory_declined: 0,
  laboratory_progress: 0,
  laboratory_wait: 0,
}

export default {
  state: {
    ...laboratoryColumnState,
    timeslots: [],
    timeslotsStatistic: initialTimeslotsStatistic,
    isLoading: true,
    plate_truck_like: '',
    culture_id: null,
    supplier_id: null,
    time_from: null,
    time_to: null,
    truck_status: '',
    quota_id: null,
    sort: '',
    page: 1,
    pagination: initialPagination,
    currentStep: {
      step: 1,
      data: {},
    },
  },

  getters: {
    ...laboratoryColumnGetters,
    [GET_TIMESLOTS_FROM_STATE]: state => state.timeslots,
    [GET_TIMESLOTS_STATISTIC_FROM_STATE]: state => state.timeslotsStatistic,
    [GET_IS_LOADING_TIMESLOTS]: state => state.isLoading,
    [GET_TIMESLOTS_PAGINATION]: state => state.pagination,
    [GET_TIMESLOTS_CURRENT_STEP]: state => state.currentStep,
    [GET_TERMINAL_QUOTA_FILTER]: state => state.quota_id,
  },

  actions: {
    ...laboratoryColumnActions,
    [FETCH_TIMESLOTS]({ state, commit, rootGetters }) {
      const {
        pagination,
        plate_truck_like,
        culture_id,
        truck_status,
        sort,
        supplier_id,
        page,
        time_from,
        time_to,
        quota_id,
      } = state
      const terminalCurrentId =
        rootGetters[actionsCommon.GET_TERMINAL_CURRENT_ID] || null

      const requestData = {
        unload_id: terminalCurrentId,
        'per-page': pagination.perPage,
        plate_truck_like,
        culture_id,
        truck_status,
        sort,
        supplier_id,
        page,
        time_from,
        time_to,
        parent_quota_id: quota_id,
      }

      if (terminalCurrentId) {
        commit(SET_IS_LOADING_TIMESLOTS, true)

        API.laboratory
          .get(requestData)
          .then(({ headers, data }) => {
            const pagination = preparePagination(headers)

            commit(SET_TIMESLOTS, data?.items || [])
            commit(
              SET_TIMESLOTS_STATISTICS,
              data?.statistics || initialTimeslotsStatistic,
            )
            commit(SET_TIMESLOTS_PAGINATION, pagination)
          })
          .catch(error => console.log('error', error))
          .finally(() => commit(SET_IS_LOADING_TIMESLOTS, false))
      }
    },
    [CHANGE_TIMESLOTS_REQUEST_FILTER_PARAMS]({ commit, dispatch }, payload) {
      commit(SET_TIMESLOTS_REQUEST_FILTER_PARAMS, payload)
      dispatch(FETCH_TIMESLOTS)
    },
    [CHANGE_TIMESLOTS_REQUEST_SORT_PARAMS]({ commit, dispatch }, payload) {
      commit(SET_TIMESLOTS_REQUEST_SORT_PARAMS, payload)
      dispatch(FETCH_TIMESLOTS)
    },
    [CHANGE_TIMESLOTS_PAGINATION_PER_PAGE]({ commit, dispatch }, payload) {
      commit(SET_TIMESLOTS_PAGINATION_PER_PAGE, payload)
      dispatch(FETCH_TIMESLOTS)
    },
    [CHANGE_TIMESLOTS_PAGINATION_NEW_PAGE]({ commit, dispatch }, payload) {
      commit(SET_TIMESLOTS_PAGINATION_CURRENT_PAGE, payload)
      dispatch(FETCH_TIMESLOTS)
    },
  },

  mutations: {
    ...laboratoryColumnMutations,
    [SET_TIMESLOTS](state, payload) {
      state.timeslots = payload
    },
    [SET_TIMESLOTS_STATISTICS](state, payload) {
      state.timeslotsStatistic = payload
    },
    [SET_IS_LOADING_TIMESLOTS](state, payload) {
      state.isLoading = payload
    },
    [SET_TIMESLOTS_REQUEST_FILTER_PARAMS](state, payload) {
      state.plate_truck_like = payload.search
      state.culture_id = payload.culture?.length ? payload.culture : null
      state.supplier_id = payload.supplier?.length ? payload.supplier : null
      state.truck_status = payload.statuses?.length ? payload.statuses : null
      state.time_from = payload.time_from
      state.time_to = payload.time_to
      state.quota_id = payload.quota_id
    },
    [SET_TIMESLOTS_QUOTA_FILTER](state, payload) {
      state.quota_id = payload
    },
    [SET_TIMESLOTS_REQUEST_SORT_PARAMS](state, payload) {
      state.sort = payload
    },
    [SET_TIMESLOTS_PAGINATION](state, payload) {
      state.pagination = payload
    },
    [SET_TIMESLOTS_PAGINATION_PER_PAGE](state, payload) {
      state.pagination.perPage = payload
    },
    [SET_TIMESLOTS_PAGINATION_CURRENT_PAGE](state, payload) {
      state.page = payload
    },
    [SET_TIMESLOT_CURRENT_STEP](state, { step = 1, data = {} }) {
      state.currentStep = { step, data }
    },
  },
}
